import { logError } from '@/utils/client-error'
import { Cart, CartState } from './types'

const isObject = (value: unknown): value is Record<string, unknown> =>
  value && typeof value === 'object' && !Array.isArray(value)

const parseCart = (rawCart?: string) => {
  if (!rawCart) {
    return {}
  }
  const cart = JSON.parse(rawCart)

  if (
    !isObject(cart) ||
    Object.entries(cart).find(
      ([key, value]) =>
        typeof key !== 'string' ||
        key.split(':').length !== 2 ||
        !isObject(value) ||
        typeof value.productId !== 'string' ||
        typeof value.variantId !== 'string' ||
        typeof value.quantity !== 'number',
    )
  ) {
    logError({
      message: 'Corrupted cart data found in localStorage',
      stack: rawCart,
    })
    return {}
  }
  return cart as Cart
}

export const readCart = (handle: string): CartState => {
  const cartData = localStorage.getItem(`storefront-cart-${handle}`)
  const cart = parseCart(cartData)

  return {
    handle,
    cart,
  }
}

export const writeCart = (cartState: CartState) => {
  if (!cartState.handle) {
    return
  }
  localStorage.setItem(
    `storefront-cart-${cartState.handle}`,
    JSON.stringify(cartState.cart),
  )
}
